import type { AnalyticsEvent } from "./AnalyticsEvent.js";
import type { AnalyticsEventType } from "./AnalyticsEventType.js";
import type { LobbySettings } from "../game/LobbySettings.js";
import type { ApproximateLobbySettings } from "../game/ApproximateLobbySettings.js";


export type LobbySettingsArg = LobbySettings | ApproximateLobbySettings;


export abstract class AnalyticsProvider {
    abstract recordEvent(event: AnalyticsEvent): void;

    abstract recordGameEvent(
        eventType: AnalyticsEventType,
        setupSettings: LobbySettingsArg,
    ): void;

    abstract recordStartGame(setupSettings: LobbySettingsArg): void;

    abstract recordAbortGame(setupSettings: LobbySettingsArg): void;

    abstract recordFinishGame(setupSettings: LobbySettingsArg): void;

    abstract recordReviewGame(setupSettings: LobbySettingsArg, gameID: string): void;

    abstract recordCreateLobby(setupSettings: LobbySettingsArg): void;

    abstract recordSearchForLobby(setupSettings: LobbySettingsArg): void;
}
